import React, { FC, useEffect, useRef } from 'react';
import Header from './Header';
import Button from './Button';
import Form from './Form';
import Footer from './Footer';

import { FormattedMessage } from 'react-intl';
import '../styles/App.scss';
import translate from '../i18n/translate';

import abstraction from '../assets/icons/symbol.svg';
import { LOCALES } from '../i18n';
import { useLocation, useNavigate, useParams } from 'react-router-dom';




interface ILocaleProps {
    name: string;
    locale: string;
}

interface FrontPageProps {
    currentLocale: string;
    languageChange: (lang: string) => void;
}

const FrontPage: FC<FrontPageProps> = ({ currentLocale, languageChange }) => {

    const params = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!['/ru', '/en'].includes(location.pathname)) {
            navigate('/' + currentLocale);
            return;
        }

        if (params.lang && currentLocale !== params.lang) {
            languageChange(params.lang);
        }
    });

    useEffect(() => {
        document.documentElement.lang = currentLocale;
    }, [currentLocale]);

    const languages: ILocaleProps[] = [
        { name: 'Русский', locale: LOCALES.RUSSIAN },
        { name: 'English', locale: LOCALES.ENGLISH }
    ];

    const myRef = useRef<HTMLDivElement>(null);
    const scrollToRef = (ref: React.RefObject<HTMLDivElement>) => {
        ref.current?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
    };

    const executeScroll = () => {
        scrollToRef(myRef);
        myRef.current?.querySelector<HTMLInputElement>('#feedback-name')?.focus({ preventScroll: true });
    };

    return (
        <div>
            <a className='skip-link' href='#main-content'>{currentLocale === 'en' ? 'Skip to content' : 'Перейти к содержимому'}</a>
            <main id='main-content' tabIndex={-1}>
                <section className='main_sec'>
                    <div className='switcher'>
                        <label htmlFor='site-language'>{currentLocale === 'en' ? 'Language' : 'Язык'}</label>
                        <select id='site-language' value={currentLocale} onChange={(locale) => {
                            languageChange(locale.target.value);
                            navigate('/' + locale.target.value);
                        }}>
                            {languages.map(({ name, locale }) => (
                                <option key={locale} value={locale}>
                                    {name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className='main_sec-wrapper'>
                        <Header/>
                        <div className='container'>
                            <div className='cover_outside'>
                                <div className='left'>
                                    <h1><FormattedMessage id='headerTitle'/></h1>
                                    <p className='name' style={{ fontSize: '5rem' }}>{translate('axiDecisionName')}</p>
                                    <p className='name'>{translate('axiDecisionFullName')}</p>
                                    <Button onClick={executeScroll}>{translate('getDemo')}</Button>
                                </div>
                                {/*<div className='right'>*/}
                                {/*    <img src={abstraction} alt='abstraction'/>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </div>
                </section>

                <section className='what_is' style={{ marginBottom: '4rem'}}>
                    <div className='container'>
                        <h2>{translate('aboutCompany')}</h2>
                        <p>{translate('companyInfo')}</p>
                        <p style={{ paddingTop: '1rem' }}>{translate('companyMission')}</p>
                        <p className='bold'>{translate('companyExperience')}</p>
                    </div>
                </section>

                <section className='what_is'>
                    <div className='container'>
                        <h2>{translate('whatIs')}<b>{translate('axiDecision')}{translate('questionMark')}</b></h2>
                        <p>{translate('axiDecisionDescMain')}</p>
                        <p className='bold'>{translate('manageRequests')}</p>
                    </div>
                </section>

                <section className='decision'>
                    <div className='container'>
                        <p className='top'>{translate('axiDecisionDesc')}</p>
                        <div className='setting-list'>
                            <div className='setting_block'><p>{translate('fn_check')}</p></div>
                            <div className='setting_block'><p>{translate('fn_gui')}</p></div>
                            <div className='setting_block'><p>{translate('fn_audit')}</p></div>
                            <div className='setting_block'><p>{translate('fn_development')}</p></div>
                            <div className='setting_block'><p>{translate('fn_permissions')}</p></div>
                            <div className='setting_block'><p>{translate('fn_customization')}</p></div>
                            <div className='setting_block'><p>{translate('fn_integrity')}</p></div>
                            <div className='setting_block'><p>{translate('fn_models')}</p></div>
                        </div>

                        <p className='top'><b>{translate('advantages')}</b></p>
                        <p className='undertext'>{translate('experience')}</p>
                        <div className='setting-list'>
                            <div className='setting_block'>
                                <p>{translate('lowCost')}</p>
                            </div>
                            <div className='setting_block'>
                                <p>{translate('lowCode')}</p>
                            </div>
                            <div className='setting_block'>
                                <p>{translate('presets')}</p>
                            </div>
                            <div className='setting_block'>
                                <p>{translate('fastIntegration')}</p>
                            </div>
                            <div className='setting_block'>
                                <p>{translate('supportCostReduction')}</p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className='demo'>
                    <div className='container _flex'>
                        <div className='demo-prices'>
                            <div className='demo-prices__order'>
                                <span>{translate('connectionAndService')}</span>
                            </div>
                            <div className='demo-prices__desc'>
                                <span>{translate('connectionAndServiceCostInd')}</span>
                            </div>
                            <div className='demo-prices__desc'>
                                <span>{translate('connectionAndServiceCostMonthly')}</span>
                            </div>
                            <div className='demo-prices__desc' style={{ paddingTop: '1rem' }}>
                                <span>{translate('onPremise')}</span>
                            </div>
                            <div className='setting-list'>
                                <div className='setting_block'>
                                    <p>{translate('onPremise1')}</p>
                                </div>
                                <div className='setting_block'>
                                    <p>{translate('onPremise2')}</p>
                                </div>
                            </div>
                        </div>
                        {/*<div className='demo-prices'>*/}
                        {/*<div className='demo-prices__order'>*/}
                        {/*    <span>от 30 000 &#8381;/{translate('month')}</span>*/}
                        {/*</div>*/}
                        {/*<div className='demo-prices__desc'>*/}
                        {/*<span>{translate('connectionCost')}</span>*/}
                        {/*</div>*/}
                        {/*</div>*/}
                        {/*<div className='demo-prices'>*/}
                        {/*    <div className='demo-prices__order'>*/}
                        {/*        <span>от 5 000 &#8381;/{translate('month')}</span>*/}
                        {/*    </div>*/}
                        {/*    <div className='demo-prices__desc'>*/}
                        {/*        <span>{translate('service')}</span>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                </section>

                <div ref={myRef}>
                    <Form/>
                </div>
            </main>
            <Footer/>
        </div>
    );
};

export default FrontPage;
